import {FC, PropsWithChildren, useMemo, useState} from "react";
import {injectChild} from "@constructor/functions";

interface TabsProps {
    initial_tab?: number;
}

interface TabsChildProps {
    active_tab: number;
    set_active_tab: (tab: number) => void;
}

const Tabs: FC<PropsWithChildren<TabsProps>> = ({initial_tab = 0, children}) => {

    const [currentTab, setTab] = useState(initial_tab);
    const data = useMemo<TabsChildProps>(() => ({
        active_tab: currentTab,
        set_active_tab: setTab
    }), [currentTab]);

    return injectChild(data, children);
}

export default Tabs;